module.exports = "https://web-assets.ifttt.com/packs/media/icons/star-071cfb31.png";